import React from 'react';
import './App.css';
import OrderSummary from './OrderSummary';
import ChatWindow from './ChatWindow';

function App() {
  return (
    <div className="chatbot-store-container">
      <div className="order-summary-container">
        <OrderSummary />
      </div>
      <div className="chat-window-container">
        <ChatWindow />
      </div>
    </div>
  );
}

export default App;
